
import { FooterSection } from "@/components/landing/FooterSection";

export default function AboutUs() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container max-w-4xl mx-auto px-6 py-16 md:py-24">
        <h1 className="text-4xl md:text-5xl font-bold text-center mb-12 text-foreground">About Testera</h1>
        
        <section className="mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold mb-4 text-foreground">The Problem</h2>
          <div className="space-y-4 text-foreground dark:text-foreground-dark light:text-foreground-light">
            <p>
              Testera began when we experienced a frustration familiar to hiring managers everywhere. 
              After sitting through yet another interview with a candidate who lacked basic skills, we realized 
              both parties had wasted valuable time on a meeting that never should have happened.
            </p>
            <p>
              The hiring system was clearly broken. Recruiters rush through hundreds of resumes, 
              spending mere seconds on each. Companies build complex screening processes with keyword 
              searches and multiple assessments, yet technical teams still spend hours in pointless interviews. 
              Candidates prepare extensively for opportunities they have no real chance at securing.
            </p>
          </div>
        </section>
        
        <section className="mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold mb-4 text-foreground">Our Solution</h2>
          <div className="space-y-4 text-foreground dark:text-foreground-dark light:text-foreground-light">
            <p>
              We built Testera to fix this broken system. Our platform uses AI to create tailored 
              assessments that measure actual capabilities, not just keywords. Candidates demonstrate 
              their skills asynchronously, and our AI evaluations provide genuine insights about 
              their problem-solving approaches. Our AI in hiring manifesto explains our position on the matter.
            </p>
          </div>
        </section>
        
        <section className="mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold mb-4 text-foreground">Our Vision</h2>
          <div className="space-y-4 text-foreground dark:text-foreground-dark light:text-foreground-light">
            <p>
              Testera is creating a more efficient and fair hiring ecosystem where:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                <span className="italic font-medium text-secondary dark:text-secondary">Time is respected</span> — Teams focus only on truly qualified candidates
              </li>
              <li>
                <span className="italic font-medium text-secondary dark:text-secondary">Skills matter more than keywords</span> — Candidates are evaluated on demonstrated abilities
              </li>
              <li>
                <span className="italic font-medium text-secondary dark:text-secondary">Opportunities are accessible</span> — Geographic and circumstantial barriers are reduced
              </li>
              <li>
                <span className="italic font-medium text-secondary dark:text-secondary">Human judgment is enhanced</span> — AI handles screening so people can focus on meaningful conversations
              </li>
            </ul>
            <p className="mt-4">
              We're not just improving a process—we're making hiring work better for everyone involved. 
              By transforming that initial screening bottleneck, we're helping businesses find better talent 
              faster while giving candidates fair opportunities to showcase their true potential.
            </p>
          </div>
        </section>
        
        <section className="mb-12 p-6 rounded-lg bg-card border border-border">
          <h2 className="text-2xl md:text-3xl font-semibold mb-4 text-foreground">Join Us</h2>
          <p className="text-foreground dark:text-foreground-dark light:text-foreground-light">
            Whether you're a hiring manager tired of wasting time on mismatched candidates, or a job seeker 
            looking for opportunities that truly match your skills, Testera is built for you. Join us in 
            creating a more efficient and equitable hiring ecosystem.
          </p>
        </section>
      </div>
      <FooterSection />
    </div>
  );
}
